<script setup lang="ts">
  import { computed } from 'vue';

  import type { Email, Task } from '@stuut/api/models';
  import { getTaskType } from '@stuut/api/models';
  import { Button } from '@ui/components/button';

  const props = defineProps<Props>();

  const emits = defineEmits<{
    (e: 'beforeTaskOpen'): void;
    (e: 'openTask', task: Task): void;
  }>();

  interface Props {
    email: Email;
  }

  const emailTasks = computed(() =>
    props.email?.tasks?.filter((task) => !task.isArchived && !task.isReplyRequired),
  );

  const handleOpen = (task: Task) => {
    emits('beforeTaskOpen');
    emits('openTask', task);
  };
</script>

<template v-if="emailTasks?.length">
  <div
    v-for="task in emailTasks"
    :key="task.id"
    class="relative py-3 flex items-center gap-3 xl:gap-x-10 cursor-pointer text-muted-foreground transition-colors truncate group"
    @click="handleOpen(task)"
  >
    <div class="flex flex-col gap-y-1 flex-1 min-w-0 truncate">
      <span class="text-2xs uppercase tracking-widest font-semibold">{{
        getTaskType(task.type)
      }}</span>

      <p class="text-xs truncate">
        {{ task.label }}
      </p>
    </div>

    <div class="flex items-center justify-end flex-nowrap gap-x-0.5 pr-0.5">
      <Button
        variant="transparent"
        size="sm"
        class="opacity-0 group-hover:opacity-100 group-hover:underline pr-0 group-hover:pr-2 transition-all"
        >View task</Button
      >

      <i
        class="fa fa-arrow-right text-muted-foreground/60 text-xs shrink-0 transition-transform group-hover:translate-x-0.5 group-hover:text-foreground"
      />
    </div>
  </div>
</template>
